import { render, staticRenderFns } from "./IOWs.vue?vue&type=template&id=4392437b"
import script from "./IOWs.vue?vue&type=script&lang=js"
export * from "./IOWs.vue?vue&type=script&lang=js"
import style0 from "./IOWs.vue?vue&type=style&index=0&id=4392437b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports